import type { InquiryItem } from '@/types/api';
import InquiryProfile from './InquiryProfile';
import InquiryItemBody from './InquiryItemBody';

const LeftContentSection = ({ inquiry }: { inquiry: InquiryItem }) => {
  return (
    <div className="flex flex-col gap-2">
      <InquiryProfile inquiry={inquiry} />
      {/* 2. 문의 본문 및 이미지 */}
      <InquiryItemBody inquiry={inquiry} />
    </div>
  );
};

export default LeftContentSection;
